import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ModalsModule } from '../../modals/modals.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AccountTodosRouting } from './account-todos.routing';
import { AccountTodosLayoutComponent } from './layout/account-todos-layout.component';
import { AccountTodosDashboardComponent } from './dashboard/account-todos-dashboard.component';
import { QuillModule } from 'ngx-quill';
import { AccountTodosAllComponent } from './all/account-todos-all.component';
import { AccountTodosReviewComponent } from './all/todo-review/account-todo-review.component';
import { TodoAdvancedFilterComponent } from './all/advanced-filter/todo-advanced-filter.component';

@NgModule({
  declarations: [
    AccountTodosAllComponent,
    AccountTodosDashboardComponent,
    AccountTodosLayoutComponent,
    AccountTodosReviewComponent,
    TodoAdvancedFilterComponent,
  ],
  exports: [
    AccountTodosAllComponent,
    AccountTodosDashboardComponent,
    AccountTodosLayoutComponent,
    AccountTodosReviewComponent,
    TodoAdvancedFilterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ModalsModule,
    SharedModule,
    QuillModule,
    ReactiveFormsModule,
    AccountTodosRouting,
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    CollapseModule.forRoot(),
  ],
})
export class AccountTodosModule {
  constructor() {
    console.log('>>> Bootstrap AccountTodosModule');
  }
}
